module.exports = __webpack_public_path__ + "static/media/LevelUp.b102ebff.png";